import ResponsibleStayApp from '@/vue/responsible-stay/App.vue'
import { createApp } from 'vue'

export default async function starter_responsibleStay() {
  let targetSection = document.querySelector('#responsible-stay-container')

  if (!targetSection) {
    targetSection = document.createElement('div')
    targetSection.id = 'responsible-stay-container'
    document.body.appendChild(targetSection)
  }

  const app = createApp(ResponsibleStayApp)
  app.mount('#responsible-stay-container')

}
